import { ResourceItem } from "../ResourceItem";
import { createFullClassResource } from "../../fullResource";

export class Chain extends ResourceItem {
  name: string = "";
  constructor(data?: any) {
    super(data);
    if (data) {
      this.name = data.name;
    }
  }

  getPostData(): any {
    return {
      name: this.name,
    };
  }
}

export const chainResource = createFullClassResource("crm/chain/", Chain);
